module.exports = __webpack_public_path__ + "static/media/Daniel.4b55966b.jpg";